import OffersComponent from '@/components/Pages/Offers.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers',
  name: RouteNames.Offers,
  component: OffersComponent,
  props: routeParameter => ({ referrer: routeParameter.query.referrer }),
};

export default route;
